import React from "react";

export const IconParkTwotone = ({ className }) => {
  return (
    <img
      className={`absolute top-0 left-0 w-[42px] h-[42px] ${className}`}
      alt="Icon park twotone"
    />
  );
};
